// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__2_i6q","footer":"ModalError_footer__166TG"};